import { LitElement, html, css, unsafeCSS } from 'lit';
import Sortable from 'sortablejs';
import styles from './sortableList.scss?inline';

export default class SotbitSortableList extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {};

    constructor() {
        super();
        this.elementOrder = [];
    }

    firstUpdated() {
        Sortable.create(this, {
            draggable: 'sotbit-sortable-list > :not([fixed])',
            handle: '.drag-handle',
            forceFallback: true,
            onUpdate: this._onUpdate.bind(this),
            onStart: this._onStart.bind(this),
            onEnd: this._onEnd.bind(this),
        });
    }

    handleSlotChange(e) {
        const slot = e.target;
        const elements = slot.assignedElements({ flatten: true });
        this.elementOrder = elements?.map((el) => {
            return el.dataset.fieldName;
        });
    }

    _onUpdate() {
        this.dispatchEvent(
            new CustomEvent('sortableUpdate', {
                bubbles: true,
                cancelable: false,
                detail: this.elementOrder,
            })
        );
    }

    _onStart() {
        this.classList.add('move');
    }

    _onEnd() {
        this.classList.remove('move');
    }

    render() {
        return html`
            <div class="sortable-list-wrapper">
                <slot class="sortable-list-item" @slotchange=${this.handleSlotChange}> </slot>
            </div>
        `;
    }
}
